import { render, staticRenderFns } from "./kafka.vue?vue&type=template&id=ed702fc6&"
import script from "./kafka.vue?vue&type=script&lang=js&"
export * from "./kafka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports